<app-ag-grid [columnDefs]="columnDefs"
             [rowData]="rows"
             [paginationPageSize]="limit$ | async"
             [pinnedBottomRowData]="totals"
             [gridOptions]="gridOptions"
             [defaultColDef]="defaultColDef"
             [suppressContextMenu]="true"
             (firstDataRendered)="tableDataChanged($event)"
             (rowDataChanged)="tableDataChanged($event)"
             (sortChanged)="tableChanged($event)"
             (filterChanged)="tableChanged($event)"
             (paginationPageSizedChanged)="onPaginationPageSizeChanged($event)">
</app-ag-grid>
